<template>
<div>
  <el-dialog
    :title="$t('common.viewMsg')"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose">
    <option-box-component :docCode="docCode" :key="docCode"></option-box-component>
    <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogVisible = false">{{$t('common.trueText')}}</el-button>
  </span>
  </el-dialog>
</div>
</template>
<script>
import optionBoxComponent from "./optionBoxComponent";
export default {
  data() {
    return {
      dialogVisible: false,
      listData: [],
      docCode:''
    };
  },
  components:{
    optionBoxComponent,
  },
  methods: {
    handleClose(done) {
      done();
    },
    handleOpen(item){
      this.docCode = item.docCode;
      this.dialogVisible = true;
    }
  }
};
</script>

<style scoped lang="scss">
  .box {
    max-height: 460px;
    overflow: auto;

    .box-in {
      border-bottom: 0.5px solid #a8a8b3;
      margin-bottom: 20px;
    }
  }
</style>
